<div class="alerts">
    <div class="alerts__container">
        <transition v-for="alert in messages" :key="alert.id" name="slide-fade">
            <div class="alerts__alert" :class="`alerts__alert-${alert.class}`">
                <p>{{ typeof alert.content === 'object' ? alert.content.message : alert.content }}</p>
            </div>
        </transition>
    </div>
</div>
